import { RootState } from "@/store/types";
import { GetterTree } from "vuex";
import { TOWER_REVIEW_DATA } from "./mutation_types";
import { TowerState } from "./types";

export function getNames(
  list: string,
  choices: Record<string, string>
): string {
  const parts = list.split(",");
  if (parts.length == 0) return "";

  const newList: Array<string> = [];
  parts.forEach(part => {
    newList.push(choices[part]);
  });

  return newList.join(", ");
}

export const getters: GetterTree<TowerState, RootState> = {
  [TOWER_REVIEW_DATA](state): Array<Record<string, any>> {
    if (!state.data.towerReview) {
      return [];
    } else {
      return state.data.towerReview;
    }
  }
};
